if (!window.__ffFaqInit) {
  window.__ffFaqInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ff-faq__question');
    if (!btn) return;

    var item = btn.closest('.ff-faq__item');
    if (!item) return;

    // Debounce - ignoruj druhy click do 150ms (duplicitni listener / event bubbling)
    var now = Date.now();
    if (item.__ffLastClick && (now - item.__ffLastClick) < 150) {
      return;
    }
    item.__ffLastClick = now;

    var isOpen = item.classList.contains('is-open');

    var accordion = item.closest('.ff-faq__accordion');
    if (accordion) {
      accordion.querySelectorAll('.ff-faq__item.is-open').forEach(function (el) {
        if (el === item) return;
        el.classList.remove('is-open');
        var q = el.querySelector('.ff-faq__question');
        if (q) q.setAttribute('aria-expanded', 'false');
      });
    }

    if (isOpen) {
      item.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    } else {
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
  }, true);

}